import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { FiMenu } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import { FaFacebookF, FaGithub, FaLinkedinIn } from "react-icons/fa";
import { logo } from "../../assets/index";
import { navLinksdata } from "../../constants";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className="w-full h-20 sticky top-0 z-50 mx-auto flex justify-between items-center px-6 lgl:px-16 transition-all duration-300"
      style={{
        background: scrolled
          ? "rgba(10,11,13,0.92)"
          : "transparent",
        backdropFilter: scrolled ? "blur(16px)" : "none",
        borderBottom: scrolled ? "1px solid #1e2228" : "1px solid transparent",
      }}
    >
      {/* Logo */}
      <div className="flex items-center gap-3">
        <div
          style={{
            width: "36px",
            height: "36px",
            borderRadius: "8px",
            background: "#ff014f",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "'JetBrains Mono', monospace",
            fontWeight: 700,
            fontSize: "16px",
            color: "#fff",
            letterSpacing: "-1px",
          }}
        >
          BB
        </div>
        <span
          style={{
            fontFamily: "'Syne', sans-serif",
            fontWeight: 700,
            fontSize: "16px",
            color: "#f0f2f5",
            letterSpacing: "0.05em",
          }}
        >
          BIPRO
        </span>
        <span
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "11px",
            color: "#ff014f",
            background: "#ff014f15",
            border: "1px solid #ff014f33",
            borderRadius: "4px",
            padding: "2px 6px",
          }}
        >
          v2.0
        </span>
      </div>

      {/* Desktop Nav */}
      <ul className="hidden mdl:flex items-center gap-8">
        {navLinksdata.map(({ _id, title, link }) => (
          <li key={_id}>
            <Link
              activeClass="active"
              to={link}
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              style={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: "13px",
                color: "#8892a4",
                cursor: "pointer",
                transition: "color 0.2s ease",
                letterSpacing: "0.03em",
              }}
              onMouseEnter={e => (e.target.style.color = "#ff014f")}
              onMouseLeave={e => (e.target.style.color = "#8892a4")}
            >
              {title}
            </Link>
          </li>
        ))}
      </ul>

      {/* Hire Me button */}
      <a
        href="mailto:biprodas.barai@gmail.com"
        className="hidden mdl:flex items-center gap-2"
        style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: "12px",
          color: "#ff014f",
          border: "1px solid #ff014f55",
          borderRadius: "6px",
          padding: "8px 16px",
          transition: "all 0.3s ease",
          background: "transparent",
          textDecoration: "none",
        }}
        onMouseEnter={e => {
          e.currentTarget.style.background = "#ff014f";
          e.currentTarget.style.color = "#fff";
        }}
        onMouseLeave={e => {
          e.currentTarget.style.background = "transparent";
          e.currentTarget.style.color = "#ff014f";
        }}
      >
        <span style={{ width: "6px", height: "6px", borderRadius: "50%", background: "#ff014f", display: "inline-block", animation: "pulse-red 2s infinite" }} />
        Hire Me
      </a>

      {/* Mobile hamburger */}
      <span
        onClick={() => setShowMenu(!showMenu)}
        className="mdl:hidden text-xl inline-flex items-center justify-center cursor-pointer"
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "8px",
          background: "#13151a",
          border: "1px solid #1e2228",
          color: "#ff014f",
        }}
      >
        <FiMenu />
      </span>

      {/* Mobile Menu */}
      {showMenu && (
        <div
          className="w-[80%] h-screen overflow-y-auto absolute top-0 left-0 p-6 scrollbar-hide"
          style={{
            background: "rgba(10,11,13,0.97)",
            backdropFilter: "blur(20px)",
            borderRight: "1px solid #1e2228",
          }}
        >
          <div className="flex flex-col gap-8 relative">
            {/* Close */}
            <span
              onClick={() => setShowMenu(false)}
              className="absolute top-0 right-0 text-gray-400 text-2xl cursor-pointer"
              style={{ transition: "color 0.2s" }}
              onMouseEnter={e => (e.currentTarget.style.color = "#ff014f")}
              onMouseLeave={e => (e.currentTarget.style.color = "#8892a4")}
            >
              <MdClose />
            </span>

            <div style={{ marginTop: "16px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "12px" }}>
                <div style={{ width: "32px", height: "32px", borderRadius: "6px", background: "#ff014f", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'JetBrains Mono'", fontWeight: 700, color: "#fff", fontSize: "13px" }}>BB</div>
                <span style={{ fontFamily: "'Syne'", fontWeight: 700, color: "#f0f2f5" }}>Biprodas Barai</span>
              </div>
              <p style={{ fontFamily: "'JetBrains Mono'", fontSize: "11px", color: "#8892a4", lineHeight: 1.7 }}>
                Backend & Platform Engineer · Node.js · TypeScript · Kubernetes · AWS · CI/CD
              </p>
            </div>

            <ul className="flex flex-col gap-2">
              {navLinksdata.map((item) => (
                <li key={item._id}>
                  <Link
                    onClick={() => setShowMenu(false)}
                    activeClass="active"
                    to={item.link}
                    spy smooth offset={-70} duration={500}
                    style={{
                      display: "block",
                      padding: "10px 14px",
                      fontFamily: "'JetBrains Mono', monospace",
                      fontSize: "13px",
                      color: "#8892a4",
                      borderRadius: "6px",
                      border: "1px solid transparent",
                      cursor: "pointer",
                      transition: "all 0.2s",
                    }}
                  >
                    <span style={{ color: "#ff014f", marginRight: "8px" }}>›</span>
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>

            <div>
              <p style={{ fontFamily: "'JetBrains Mono'", fontSize: "11px", color: "#4a5568", marginBottom: "12px", textTransform: "uppercase", letterSpacing: "0.1em" }}>Find me in</p>
              <div className="flex gap-3">
                <span className="bannerIcon"><a href="https://www.facebook.com/bipro.barai.503"><FaFacebookF /></a></span>
                <span className="bannerIcon"><a href="https://github.com/bipro-b?tab=repositories"><FaGithub /></a></span>
                <span className="bannerIcon"><a href="https://www.linkedin.com/in/bipro-barai-419381179/"><FaLinkedinIn /></a></span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;